import React from 'react';
import { Col, Row, FormGroup } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { DecimalBox, Form } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

class DecimalBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: 123456789
			}
		};
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	handleCustomValidationValidate = (value) => {
		if (value > 5000)
			return "Amount cannot be greater than $5,000";
	}

	render() {
		return (
			<Box title="DecimalBox">
				<Form
					values={this.state.form}
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Default</Label>
								<DecimalBox name="default" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Placeholder</Label>
								<DecimalBox name="placeholder" placeholder="Total" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Disabled</Label>
								<DecimalBox name="disabled" disabled={true} />
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Preset</Label>
								<DecimalBox name="preset" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default" required>Required</Label>
								<DecimalBox name="required" required />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default" required>Precision (4)</Label>
								<DecimalBox name="precision" precision={4} />
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label required>Validation (&lt; 5000)</Label>
								<DecimalBox name="customValidation" onValidate={this.handleCustomValidationValidate} required />
							</FormGroup>
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default DecimalBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/DecimalBoxDemo.js